<fieldset>
  <legend>{{legend}}</legend>
  @if(!documents){
  <div><code>Loading...</code></div>
  }
  @else{
  <mat-card appearance="outlined">
    @if(!hwSession){
    <mat-card-content>
      <code>...Starting session</code>
    </mat-card-content>
    }
    @else {
    <mat-card-actions align="end">
      <a matButton [href]="hwSession.launchUrl" target="_blank" [disabled]="!hwSession" (click)="searching=true"><mat-icon aria-hidden="true">open_in_new</mat-icon>Search</a>
      <button matButton [disabled]="!searching" (click)="stopSearching()"><mat-icon aria-hidden="true">call_end</mat-icon> End</button>
    </mat-card-actions>
    }
  </mat-card>
  <mat-form-field>
    <mat-label>Filter</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Term to search..." #input>
  </mat-form-field>
  <div class="document-container">
    @for(doc of documents; track $index){
    <mat-card class="document">
      <mat-card-header>
        <mat-card-title>{{doc.articleTitle}}</mat-card-title>
        <mat-card-subtitle>Type: {{ doc.docType }}, Version: {{doc.docVersion}}</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <hr />
        <p>
          <span aria-label="Status">
            <code><b>Status: </b>{{doc.status}} </code>|
            <code><b> Method: </b>{{doc.method}}</code>
          </span>
        </p>
        <p>
          <span aria-label="Sent date">
            <code><b>Sent Date: </b>{{doc.dateSent | date: 'MM/dd/yyyy hh:mm a'}}</code>
          </span>
        </p>
        <p>
          <span aria-label="Watch date">
            <code><b>Watched Date: </b>{{doc.dateWatched | date: 'MM/dd/yyyy hh:mm a'}}</code>
          </span>
        </p>
      </mat-card-content>
      <mat-card-actions align="end">
        <button matButton (click)="openDocument(doc.id)"><mat-icon aria-hidden="true">visibility</mat-icon> Open</button>
      </mat-card-actions>
    </mat-card>
    }
  </div>
  @if(documents.length === 0){
  <mat-card class="no-data-found">
    <mat-card-content>
      -- No documents found --
    </mat-card-content>
  </mat-card>
  }
  }
  <mat-paginator (page)="pageChanged($event)"
                 [length]="length"
                 [pageIndex]="pageIndex"
                 [pageSizeOptions]="pageSizeOptions"
                 showFirstLastButtons
                 aria-label="Select page of elements">
  </mat-paginator>
</fieldset>
